import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { RemoveButton } from '@/modules/pmt/components/RemoveButton';
import { ShipmentLogo } from '@/modules/pmt/components/ShipmentLogo';
import { useShipmentDetailsContext } from '@/modules/pmt/context';
import { ShipmentSearchStatus } from '@/modules/pmt/interfaces';
import {
  BackArrowButton,
  HeaderContent,
  HeaderWrapper,
  MerchantName,
  TrackingIdText,
} from './TrackingDetailHeader.styles';

interface ITrackingDetailHeader {
  label?: string;
  eventHeaderState: ShipmentSearchStatus;
  isSMEShipment?: boolean;
  isESShipment?: boolean;
  shipmentLogo?: string;
  merchantName?: string;
}

const ALLOWED_SHIPMENT_DELETE_STATES = [ShipmentSearchStatus.Fetched, ShipmentSearchStatus.Timeout];

export const TrackingDetailHeader: React.FC<ITrackingDetailHeader> = ({
  label,
  eventHeaderState,
  isSMEShipment = false,
  isESShipment = false,
  shipmentLogo,
  merchantName,
}) => {
  const { setShowDetailsView } = useShipmentDetailsContext();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);

  if (!label) return null;

  const onBack = () => {
    setShowDetailsView(false);
  };

  const isDisabled = !ALLOWED_SHIPMENT_DELETE_STATES.includes(eventHeaderState);
  const logoSize = !isDesktopPMT ? 'small' : 'large';

  if (isSMEShipment) {
    return (
      <HeaderContent>
        {!isDesktopPMT && <BackArrowButton onClick={onBack} />}
        <ShipmentLogo variant='sme' smeLogo={shipmentLogo} merchantName={merchantName} size={logoSize} />
        <HeaderWrapper>
          <TrackingIdText truncatedLines={!merchantName ? 2 : 1}>
            <span>{label}</span>
          </TrackingIdText>
          <MerchantName>{merchantName}</MerchantName>
        </HeaderWrapper>
        <RemoveButton disabled={isDisabled} />
      </HeaderContent>
    );
  }

  if (isESShipment) {
    return (
      <HeaderContent>
        {!isDesktopPMT && <BackArrowButton onClick={onBack} />}
        <ShipmentLogo variant='merchant' merchantLogo={shipmentLogo} merchantName={merchantName} size={logoSize} />
        <HeaderWrapper>
          <TrackingIdText truncatedLines={!merchantName ? 2 : 1}>
            <span>{label}</span>
          </TrackingIdText>
          <MerchantName>{merchantName}</MerchantName>
        </HeaderWrapper>
        <RemoveButton disabled={isDisabled} />
      </HeaderContent>
    );
  }

  return (
    <HeaderContent>
      {!isDesktopPMT && <BackArrowButton onClick={onBack} />}
      <TrackingIdText truncatedLines={2}>
        <span>{label}</span>
      </TrackingIdText>
      <RemoveButton disabled={isDisabled} />
    </HeaderContent>
  );
};
